import { useEffect, useState } from 'react'
import { Col, Row, Spin } from 'antd'

import { useHistoriesWidget } from '../../atoms/history/hooks'
import { historyMounted } from '../../atoms/history/model'
import { ErrorScreen } from '../../../../shared/components/errorScreen/errorScreen'
import { HistoriesList } from './components/HistoriesList'
import { HistoryFiles } from './components/HistoryFiles'

type Props = {
  clientId: string
  requestId: string
}

export const VerificationHistories = ({ clientId, requestId }: Props) => {
  const { history, historiesError, loading } = useHistoriesWidget(clientId)
  const [selectedRequestId, setSelectedRequestId] = useState<string | null>(
    null,
  )

  useEffect(() => {
    if (history && history.length > 0) {
      setSelectedRequestId(history[0].requestId)
    }
  }, [history])

  const selectedItem = history?.find(
    (item) => item.requestId === selectedRequestId,
  )

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin />
      </div>
    )
  }

  if (![0, 404, null].includes(historiesError?.code || null)) {
    return (
      <ErrorScreen
        showRetry
        onRetry={() => {
          historyMounted(clientId)
        }}
      />
    )
  }

  return (
    <Row gutter={16}>
      <Col span={8} style={{ maxHeight: 600, overflowY: 'auto' }}>
        <HistoriesList
          items={history}
          requestId={requestId}
          selectedRequestId={selectedRequestId}
          onSelect={setSelectedRequestId}
        />
      </Col>
      <Col span={16}>
        {selectedItem && (
          <HistoryFiles
            key={selectedRequestId}
            historyId={selectedRequestId!}
            browserFileNames={selectedItem.browserFileNames}
          />
        )}
      </Col>
    </Row>
  )
}
